import { RouteRecordRaw } from 'vue-router'
// 常驻路由
export const constRoute: Array<RouteRecordRaw> = [
  {
    path: '/inquiryDetail',
    name: '/inquiryDetail',
    component: () =>
      import('@/views/outpatients/inquiryIndex/inquiryDetail.vue'),
    meta: {
      title: '问诊',
      menuKey: '/outpatients',
    },
  },
  {
    path: '/msgDetail',
    name: '/msgDetail',
    component: () => import('@/views/message/detail.vue'),
    meta: {
      title: '消息详情',
      menuKey: '/msgDetail',
    },
  },
  {
    path: '/msgList',
    name: '/msgList',
    component: () => import('@/views/message/list.vue'),
    meta: {
      title: '消息列表',
      menuKey: '/msgList',
    },
  },
]
// 权限路由
export const permissionRoute: Array<RouteRecordRaw> = [
  {
    path: '/dashboard',
    name: '/dashboard',
    component: () => import('@/views/dashboard/index.vue'),
    meta: {
      title: '首页',
      menuKey: '/dashboard',
    },
  },
  {
    path: '/register',
    name: '/register',
    component: () => import('@/views/register/index.vue'),
    meta: {
      title: '挂号', // 菜单栏标题
      menuKey: '/register', // 菜单栏id
    },
  },
  {
    path: '/outpatients',
    name: '/outpatients',
    component: () => import('@/views/outpatients/index.vue'),
    meta: {
      title: '门诊',
      menuKey: '/outpatients',
    },
  },
  {
    path: '/charge',
    name: '/charge',
    component: () => import('@/views/charge/index.vue'),
    meta: {
      title: '收费',
      menuKey: '/charge',
    },
  },
  {
    path: '/execute',
    name: '/execute',
    component: () => import('@/views/execute/index.vue'),
    meta: {
      title: '执行',
      menuKey: '/execute',
    },
  },
  {
    path: '/pharmacy',
    name: '/pharmacy',
    component: () => import('@/views/pharmacy/index.vue'),
    meta: {
      title: '药房',
      menuKey: '/pharmacy',
    },
  },
  {
    path: '/inventory',
    name: '/inventory',
    component: () => import('@/views/inventory/index.vue'),
    meta: {
      title: '库存',
      menuKey: '/inventory',
    },
  },
  {
    path: '/gsp',
    name: '/gsp',
    component: () => import('@/views/gsp/index.vue'),
    meta: {
      title: 'GSP',
      menuKey: '/gsp',
    },
  },
  {
    path: '/patient',
    name: '/patient',
    component: () => import('@/views/patient/index.vue'),
    meta: {
      title: '患者',
      menuKey: '/patient',
    },
  },
  {
    path: '/marketing',
    name: '/marketing',
    component: () => import('@/views/marketing/index.vue'),
    meta: {
      title: '营销',
      menuKey: '/marketing',
    },
  },
  {
    path: '/stat',
    name: '/stat',
    component: () => import('@/views/stat/index.vue'),
    meta: {
      title: '统计',
      menuKey: '/stat',
    },
  },
  {
    path: '/manage',
    name: '/manage',
    component: () => import('@/views/manage/index.vue'),
    meta: {
      title: '管理',
      menuKey: '/manage',
    },
  },
  ...constRoute,
]
